module.exports = __webpack_public_path__ + "img/clavijas_y_enchufes.e82083eb.jpg";